import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const AlloyGatorPage = () => {
  return <main data-id="element-702" data-mp="1jhjckoddbcwn">
      <SEO title="AlloyGator Almere | Velgbescherming | BKCustoms" description="Bescherm uw velgen in Almere tegen stoepschade met AlloyGator wielkastbeschermers. Professionele installatie door BKCustoms. Duurzaam en verkrijgbaar in meerdere kleuren." canonical="/diensten/alloygator" data-id="element-703" data-mp="1jhb02xl5q9lz" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-704" data-mp="15p34h95m0oov">
        <div className="absolute inset-0 overflow-hidden" data-id="element-705" data-mp="10sw744ra4lij">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-706" data-mp="vsrs6j60ryuf"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator in Almere" className="w-full h-full object-cover object-center" data-id="element-707" data-mp="vukz7zkjol2y" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-708" data-mp="3tcv075u115b">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-709" data-mp="8kl575ezkqjj">
            <span className="text-[#D6281F]" data-id="element-710" data-mp="8mo3sdu7frzv">AlloyGator Almere</span> - Bescherm
            uw velgen
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-711" data-mp="3pz8gd5338ibi">
            Premium bescherming voor uw velgen tegen schade van stoepranden met
            onze hoogwaardige AlloyGator wielkastbeschermers in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-712" data-mp="rjpaq47bk26g">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-713" data-mp="djy10fnu57y9">
              <span className="mr-2" data-id="element-714" data-mp="2y8lrxnmfccrt">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-715" data-mp="32bqrbhb7jyc8" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-716" data-mp="3295r0wqk5qgl">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-717" data-mp="u2133o6jxcvl">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-718" data-mp="q3bh577g6n0c">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-719" data-mp="l36z3cqw5k80">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-720" data-mp="g3klv3b2c3z7">
              <div className="relative" data-id="element-721" data-mp="g4cjejo80bs4">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-722" data-mp="b59bmrguvrgg"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-723" data-mp="2ahljxlysgmy8">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg" alt="AlloyGator wielkastbeschermer in Almere" className="w-full h-auto object-cover" data-id="element-724" data-mp="25jk1n396srnt" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-725" data-mp="2rqedqpanonk9">
              <div className="flex items-center mb-6" data-id="element-726" data-mp="2rtk6qfmeo9l9">
                <div className="bg-[#D6281F]/20 p-2 rounded-full mr-4" data-id="element-727" data-mp="1v28dsfooijcb">
                  <ShieldIcon size={28} className="text-[#D6281F]" data-id="element-728" data-mp="1z2ina2bojrvx" />
                </div>
                <div className="h-px flex-grow bg-gradient-to-r from-[#D6281F] to-transparent" data-id="element-729" data-mp="2424x01saupzz"></div>
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-730" data-mp="29183zrrub6al">
                AlloyGator Velgbescherming in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-731" data-mp="3fj4oiv6tp0sy">
                AlloyGator is de ultieme bescherming voor uw voertuig in Almere!
                Onze hoogwaardige wielkastbeschermers zijn gemaakt van een
                duurzaam en flexibel materiaal dat uw velgen beschermt tegen
                stoepschade, steenslag en andere beschadigingen.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-732" data-mp="169negg4bomoo">
                Dankzij de eenvoudige installatie door onze specialisten in
                Almere en het strakke design is AlloyGator de perfecte keuze
                voor elke autoliefhebber die zijn velgen in topconditie wil
                houden.
              </p>
              <div className="space-y-4 mb-8" data-id="element-733" data-mp="1oylnsl87cr41">
                <div className="flex items-center" data-id="element-734" data-mp="1oybyz0yw8pzx">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-735" data-mp="1kwqbymsnavc0"></div>
                  <span className="text-white/90" data-id="element-736" data-mp="1yx13ls1s4dy8">
                    Beschermt tegen stoepschade en steenslag
                  </span>
                </div>
                <div className="flex items-center" data-id="element-737" data-mp="1tzhqwwkqc98e">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-738" data-mp="2djzunlwq56cf"></div>
                  <span className="text-white/90" data-id="element-739" data-mp="2dhvsp9idyhes">
                    Verkrijgbaar in verschillende kleuren
                  </span>
                </div>
                <div className="flex items-center" data-id="element-740" data-mp="23kr28xhibzs6">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-741" data-mp="28kn5guidrn6o"></div>
                  <span className="text-white/90" data-id="element-742" data-mp="28mq6saozh2qp">
                    Professionele installatie door BKCustoms in Almere
                  </span>
                </div>
                <div className="flex items-center" data-id="element-743" data-mp="1zkqo7dyblqln">
                  <div className="w-2 h-2 rounded-full bg-[#D6281F] mr-3" data-id="element-744" data-mp="1kv2kk62o2fur"></div>
                  <span className="text-white/90" data-id="element-745" data-mp="1kt80sv34sts9">
                    Duurzaam en weerbestendig materiaal
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-746" data-mp="1buwev6d7mk65">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-747" data-mp="1fwhomiug6ic4">
                  <span className="mr-2" data-id="element-748" data-mp="38stmlwxh20a8">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-749" data-mp="38td4jdn4goo9" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-750" data-mp="33uidjof03tt2">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Benefits Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-751" data-mp="3njstn3insgrp">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-752" data-mp="2g4elmeb6dihw">
          <div className="text-center mb-16" data-id="element-753" data-mp="2g1thfinemqgz">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-754" data-mp="2c2b5hcdk9pqa">
              De <span className="text-[#D6281F]" data-id="element-755" data-mp="rl22g2nxvcd6">Voordelen</span> van
              AlloyGator in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-756" data-mp="vlc4j48m1imr">
              Ontdek waarom AlloyGator de beste keuze is voor velgbescherming in
              Almere.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-757" data-mp="15cyq9uikr03r">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-758" data-mp="1abjhx5jrgbgl">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-759" data-mp="1fa32p2mmbh7d">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-760" data-mp="1fbxqcop9xnf5" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-761" data-mp="1jchpfxter13x">
                Optimale Bescherming
              </h3>
              <p className="text-white/80" data-id="element-762" data-mp="3l32swvf3kh1s">
                AlloyGator biedt superieure bescherming tegen stoepschade,
                steenslag en andere alledaagse gevaren die uw velgen kunnen
                beschadigen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-763" data-mp="1vsr2jvbajqgx">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-764" data-mp="1rrnnhb12hygr">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-765" data-mp="25kn0n6ddngl5" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-766" data-mp="20lag4s9zallq">
                Kostenbesparend
              </h3>
              <p className="text-white/80" data-id="element-767" data-mp="1cuo7ays5gxao">
                Voorkom dure reparaties of vervanging van beschadigde velgen.
                AlloyGator is een eenmalige investering die u op lange termijn
                geld bespaart.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-768" data-mp="1mr9g7v7aisjs">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-769" data-mp="1ht7xjbds0v8u">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-770" data-mp="2y77tkb9i40qt" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-771" data-mp="2t8whruznbg5y">
                Esthetisch Aantrekkelijk
              </h3>
              <p className="text-white/80" data-id="element-772" data-mp="f0luzpponf2k">
                Verkrijgbaar in verschillende kleuren om te matchen of juist te
                contrasteren met uw voertuig, voor een gepersonaliseerde look.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Color Options Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-773" data-mp="b26b3uowemtd">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-774" data-mp="yqz17aiua0g2">
          <div className="text-center mb-16" data-id="element-775" data-mp="12rhtf5on98is">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-776" data-mp="12q7t09ubjo8z">
              Beschikbare <span className="text-[#D6281F]" data-id="element-777" data-mp="oz1n9w0g4udn">Kleuren</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-778" data-mp="ty5vajbmwm2e">
              Kies uit onze selectie kleuren om uw AlloyGator te personaliseren
              bij BKCustoms in Almere.
            </p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4" data-id="element-779" data-mp="1mh1prgnjoo9x">
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-780" data-mp="134a3rntqnr3x">
              <div className="w-full aspect-square rounded-md bg-[#000000] mb-3" data-id="element-781" data-mp="182l8jk56fbfa"></div>
              <span className="text-white font-medium" data-id="element-782" data-mp="u33il1g59s4c">Zwart</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-783" data-mp="y3vs7vsxhz15">
              <div className="w-full aspect-square rounded-md bg-[#FF0000] mb-3" data-id="element-784" data-mp="kcr1jj7jgh2y"></div>
              <span className="text-white font-medium" data-id="element-785" data-mp="kaxs5w5jjir9">Rood</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-786" data-mp="p4s8qqpunhm4">
              <div className="w-full aspect-square rounded-md bg-[#0000FF] mb-3" data-id="element-787" data-mp="ag5rgjgnwfs9"></div>
              <span className="text-white font-medium" data-id="element-788" data-mp="fefrb7dc04k7">Blauw</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-789" data-mp="1exvi81mbr1c">
              <div className="w-full aspect-square rounded-md bg-[#FFFF00] mb-3" data-id="element-790" data-mp="6d982qjasfn9"></div>
              <span className="text-white font-medium" data-id="element-791" data-mp="3iw23nm2x8hr4">Geel</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-792" data-mp="3dxh65uf20c6d">
              <div className="w-full aspect-square rounded-md bg-[#00FF00] mb-3" data-id="element-793" data-mp="3rxa2q6d9hmm9"></div>
              <span className="text-white font-medium" data-id="element-794" data-mp="3rv5rt4gy3nch">Groen</span>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-4 rounded-lg text-center" data-id="element-795" data-mp="3nuddhwt7us9c">
              <div className="w-full aspect-square rounded-md bg-[#FFA500] mb-3" data-id="element-796" data-mp="5oh89tysqozr"></div>
              <span className="text-white font-medium" data-id="element-797" data-mp="q5z7lgbsiil">Oranje</span>
            </div>
          </div>
          <p className="text-white/60 text-center mt-6" data-id="element-798" data-mp="fejzppq9ruvz">
            * Meer kleuren beschikbaar op aanvraag
          </p>
        </div>
      </section>
      {/* Installation Process Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-799" data-mp="ohl0rc0a2vss">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-800" data-mp="oe73ujadvesq">
          <div className="text-center mb-16" data-id="element-801" data-mp="jirmhhd630rk">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-802" data-mp="3d9eyad00lnrr">
              Installatie <span className="text-[#D6281F]" data-id="element-803" data-mp="3d7lowpy0opg2">Proces</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-804" data-mp="3i658wkt1vr5s">
              Bij BKCustoms in Almere volgen we een zorgvuldig proces om uw
              AlloyGator perfect te installeren.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-805" data-mp="3w0ftcpy0kz61">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-806" data-mp="3w20repjjf08n">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-807" data-mp="4rsacgn8xo1n">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-808" data-mp="dtrpt4im4k2h">
                Voorbereiding
              </h3>
              <p className="text-white/80" data-id="element-809" data-mp="2bm5rqeiet59q">
                We reinigen uw velgen grondig en controleren op eventuele
                bestaande schade die moet worden gerepareerd voordat de
                AlloyGator wordt geïnstalleerd.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-810" data-mp="23anb522x73v9">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-811" data-mp="1yddmhoncuw8h">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-812" data-mp="2r1j5a5uumb5o">
                Installatie
              </h3>
              <p className="text-white/80" data-id="element-813" data-mp="2m2zmgebjxfhj">
                Onze specialisten in Almere installeren de AlloyGator zorgvuldig
                tussen de velg en de band, waarbij ze zorgen voor een perfecte
                pasvorm en afwerking.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-814" data-mp="16lpefebm0vvg">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-815" data-mp="11mcpmo16heq8">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-816" data-mp="2pgy7c51l559z">
                Afwerking
              </h3>
              <p className="text-white/80" data-id="element-817" data-mp="2gicr4gjl62cd">
                Na installatie controleren we elke AlloyGator op correcte
                plaatsing en zorgen we ervoor dat uw velgen er perfect uitzien
                met hun nieuwe bescherming.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-818" data-mp="3d7trqh3poy77">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-819" data-mp="2z9dmyvpethrp">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-820" data-mp="347nij7f1qkdu">
            Bescherm uw velgen vandaag nog in Almere!
          </h2>
          <p className="text-white/80 mb-8" data-id="element-821" data-mp="1nt5q9awnt0ny">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-822" data-mp="1kaq3m7pv0aq7">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-823" data-mp="1ga67n7h0vd5n">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-824" data-mp="1pbdy53dar9p6">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};